export enum WhiteboardStatus {
  UNASSIGNED = 0,
  ASSIGNED = 1,
  IN_USE = 2,
}

export enum LinkAccessLevel {
  RESTRICTED = 0,
  PUBLIC_VIEW = 1,
  PUBLIC_EDIT = 2,
}

export enum ShareAccessType {
  RESTRICTED = 0,
  PUBLIC = 1,
}

export enum SharePermission {
  VIEW = 0,
  EDIT = 1,
}

